<template>
    <div class="container">
        <div class="column1">
            <img class="img-responsive" :src="emptyImg" />
            <div class="column2">
                <h1>{{ $t('shared.pageNotFound.header') }}</h1>
                <p>
                    {{ $t('shared.pageNotFound.description') }}
                </p>

                <router-link to="/" exact
                    ><button class="btn">
                        {{ $t('shared.pageNotFound.goToHome') }}
                    </button>
                </router-link>
                <button
                    class="btn"
                    style="margin-left: 10%;"
                    @click="openContactUs"
                >
                    {{ $t('shared.pageNotFound.contactus') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import EmptySvg from '~/assets/img/empty.svg';
import IntercomService from '~/services/IntercomService';

export default {
    name: 'Pagenotfound',
    data: () => ({
        emptyImg: EmptySvg,
    }),
    methods: {
        openContactUs() {
            IntercomService.show();
        },
    },
};
</script>
<style scoped>
.container {
    position: relative;
    margin: auto;
    width: 85%;
    height: 100vh;
    padding-bottom: 25vh;
    display: grid;
    flex-direction: row;
    justify-content: space-around;
}
h1 {
    font-size: 5vw !important;
    color: rgba(50, 60, 83, 1) !important;
}

p {
    font-size: 2vw !important;
    color: rgba(50, 60, 83, 1) !important;
}
.column1 {
    float: left;
    width: 50%;
    height: 300px; /* Should be removed. Only for demonstration */
}
.column2 {
    position: relative;
    margin-left: 120%;
    margin-top: -90%;
    width: 80%;
}
.btn {
    background-color: #891630 !important;
    color: white;
    margin-top: 10%;
}
.img-responsive {
    width: 180%;
    height: auto;
    object-fit: scale-down;
    display: block;
    margin: auto;
}
@media only screen and (max-width: 1024px) {
    .column2 {
        float: left;
        height: 160%; /* Should be removed. Only for demonstration */
    }
    .btn {
        float: left;
        font-size: 2vw;
    }
}
</style>
